import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative py-24 md:py-36 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20atmospheric%20manga%20reading%20scene%20with%20soft%20natural%20light%20streaming%20through%20large%20windows%2C%20cozy%20reading%20nook%20with%20comic%20books%20scattered%20artfully%2C%20golden%20hour%20warm%20tones%2C%20peaceful%20and%20inviting%20mood%2C%20cinematic%20composition%2C%20soft%20bokeh%20background&width=1920&height=1080&seq=cta-bg-manga-02&orientation=landscape"
        alt="加入汗汗漫画"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 text-center">
        <h2 className="font-heading font-black text-3xl md:text-5xl lg:text-6xl tracking-wider text-white uppercase">
          加入汗汗漫画
        </h2>
        <p className="mt-5 text-sm md:text-base text-white/70 max-w-md mx-auto leading-relaxed">
          成为千万读者中的一员，第一时间获取最新漫画更新
        </p>
        <p className="text-sm md:text-base text-white/70 max-w-md mx-auto leading-relaxed">
          免费阅读，极速体验，尽在汗汗漫画
        </p>

        <div className="mt-10">
          <Link
            to="/category/all"
            className="group inline-flex items-center gap-3 px-8 md:px-10 py-3.5 md:py-4 bg-foreground-900 text-white rounded-full hover:bg-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <span className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center rounded-full bg-accent-500 shrink-0">
              <i className="ri-book-open-line text-white text-xs md:text-sm"></i>
            </span>
            <span className="text-sm md:text-base font-semibold">开始免费阅读</span>
            <i className="ri-arrow-right-up-line text-sm md:text-base"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}